<template>
  <form action="#">
    <slot />
  </form>
</template>

<script>
export default {
  name: 'app-content-body'
}
</script>
